export const formatDateOfBirth = (dateOfBirth: unknown) => {
  if (!(dateOfBirth instanceof Date)) return { day: '', month: '', year: '' };
  return {
    day: String(dateOfBirth.getDate()).padStart(2, '0'),
    month: String(dateOfBirth.getMonth() + 1).padStart(2, '0'),
    year: String(dateOfBirth.getFullYear()),
  };
};
